export enum WageEmployeeFilterType {
  All = 0,
  Employee = 1,
  ByGroup = 2,
  ByEmployeeCompany = 3,
  EmployeeStatus = 4
}

export const WageEmployeeFilterTypeMapping: Record<WageEmployeeFilterType, string> = {
  [WageEmployeeFilterType.All]: 'All Employees',
  [WageEmployeeFilterType.Employee]: 'Employee',
  [WageEmployeeFilterType.ByGroup]: 'Employee Group',
  [WageEmployeeFilterType.ByEmployeeCompany]: 'Employee Company',
  [WageEmployeeFilterType.EmployeeStatus]: 'Employee Status'
};
